import type { HarmonyPackage } from '@rhythmic/db/types'

import { useRhythmicLogger } from '#imports'

import { getPlanCollection } from '../../getCollections'

const logger = useRhythmicLogger('useHarmonyPlanContext:deletePlan')

export interface DeleteHarmonyPlanContext {
  teamId: string
  workspaceId: string
  plans?: HarmonyPackage[]
}

function validateParams(planId: string, context: DeleteHarmonyPlanContext) {
  if (!planId) {
    const error = new Error('Harmony plan identifier is required')
    logger.error('delete harmony plan blocked: missing plan identifier', {
      context,
    })
    throw error
  }
  const { teamId, workspaceId } = context
  if (!workspaceId) {
    const error = new Error('Workspace context is not ready')
    logger.error('delete harmony plan blocked: missing workspace identifier', {
      context,
    })
    throw error
  }

  return { planId, teamId, workspaceId }
}

/**
 * Deletes a harmony plan from the local collection.
 */
export default async function handleDeleteHarmonyPlan(planId: string, context: DeleteHarmonyPlanContext) {
  try {
    const { teamId, workspaceId } = validateParams(planId, context)
    const listCollection = getPlanCollection(workspaceId)
    listCollection.delete(planId)

    logger.info('Harmony plan deleted successfully', {
      planId,
      teamId,
      workspaceId,
    })
  } catch (error) {
    logger.error('Failed to delete harmony plan', { planId, context, error })
    if (error instanceof Error) throw error
    throw new Error('Failed to delete harmony plan')
  }
}
